// Thin fetch wrapper that attaches the Auth0 id_token as
// `Authorization: Bearer <jwt>` to backend requests. The token getter is
// registered once at app startup from a component that has access to the
// `@auth0/auth0-react` hook (see AppRouter.js).
//
// Backend dual-mode rollout: while `require_jwt=false` on the server, missing
// or stale tokens fall back to the legacy `?uid=` URL parameter on the
// backend. Once the server flips to `require_jwt=true`, anything without a
// valid Bearer header is rejected with 401.

let tokenGetter = async () => null;

export const registerTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const apiFetch = async (input, init = {}) => {
  let token = null;
  try {
    token = await tokenGetter();
  } catch (err) {
    // Surface for debugging but don't block the request — backend may still
    // accept it via the legacy fallback while require_jwt=false.
    console.warn("apiFetch: token getter threw", err);
  }

  const headers = new Headers(init.headers || {});
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  return fetch(input, { ...init, headers });
};
